export function clearStorage() {
  localStorage.removeItem("signup-form");
  localStorage.removeItem("quoteId");
  localStorage.removeItem("pets");
  localStorage.removeItem("signup-v2");
  localStorage.removeItem("leadSource");
}
